import React from 'react'
import { FormattedMessage } from 'react-intl'

import { NAME_BY_DIRECTION_SPELLED } from 'helpers/i18n.jsx'

export const POSTBATTLE_SCREEN_SUBTITLE_BATTLE_DIRECTION = (direction) => (
    <FormattedMessage
        id='postbattle_screen_subtitle.battle.direction'
        defaultMessage={'Наступление с {direction} плацдарма на рубежи клана'}
        values={{
            direction: NAME_BY_DIRECTION_SPELLED[direction],
        }}
    />
)



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/Subtitle/constants.jsx